import React from 'react'
import { Table as PaycodeTable } from 'components/table/paycodes/Table'

const Paycodes = () => {
    return (
        <>
            <PaycodeTable />
        </>
    )
}

export { Paycodes }